export const SOURCE_CONTEXT = 'pwr_eui_source_context';

export const getSourceContextCookie = (): string | null => {
  const cookieValue = document.cookie
    .split('; ')
    .find((row) => row.startsWith(SOURCE_CONTEXT))
    ?.split('=')[1]
    .trim();

  if (!cookieValue) return null;

  try {
    return decodeURIComponent(cookieValue);
  } catch (error) {
    if (process.env['NODE_ENV'] !== 'production') {
      console.error(error);
    }
    return null;
  }
};

export const writeSourceContextCookie = (value: string) => {
  const now = new Date();
  const time = now.getTime();
  const expireTime = time + 1000 * 60 * 60 * 2;
  now.setTime(expireTime);
  document.cookie = `${SOURCE_CONTEXT}=${encodeURIComponent(value)};expires=${now.toUTCString()}`;
};
